<template>
  <nav class="menu-desktop" @mouseleave="onFocusOut">
    <div ref="mainMenu" class="nav-menu">
      <a
        v-for="(item, i) in getItems"
        :key="i"
        :href="item.href"
        class="nav-item"
        :class="{
          'nav-item_active': item === menu.focusInfo,
          'nav-item_red': item.sectionID == 70,
        }"
        @mouseover="onFocusIn(item)"
        @click="handlerClick"
      >
        <span class="nav-item__underline">
          {{ item.name }}
        </span>
      </a>
    </div>
    <transition name="fade">
      <SubMenuDesktop
        v-if="menu.focusInfo.items && menu.focusInfo.items.length > 0 && menu.focusInfo.sectionID"
        :style="getTopMenuPosition()"
        :result="menu.focusInfo"
      />
      <SubMenuCollection
        v-else-if="menu.focusInfo.items && menu.focusInfo.items.length > 0"
        :style="getTopMenuPosition()"
        :result="menu.focusInfo"
      />
    </transition>
  </nav>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SubMenuDesktop from '@components/Menu/MenuDesktop/SubMenuDesktop.vue';
import SubMenuCollection from '@components/Menu/MenuDesktop/SubMenuCollection.vue';

export default {
  name: 'MenuDesktop',
  components: {
    SubMenuDesktop,
    SubMenuCollection,
  },
  props: ['menuObj'],
  data() {
    return {
      menu: {
        focusInfo: {},
        focusImage: {},
      },
    };
  },
  computed: {
    ...mapState({
      items: ({ results }) => results?.menus?.mainMenu?.items,
    }),
    getItems() {
      return this.items.filter((el) => el.elementCnt > 0);
    },
  },
  methods: {
    ...mapMutations({
      loaderStart: 'global/loaderStart',
    }),
    onFocusIn(item) {
      this.menu.focusInfo = item;
      this.menu.focusImage = item.image;
    },
    onFocusOut() {
      this.menu.focusInfo = {};
    },
    handlerClick(e) {
      if (e.ctrlKey || e.metaKey) return;
      this.loaderStart();
    },
    getTopMenuPosition() {
      const menu = this.$refs.mainMenu;

      return { top: `${menu.offsetTop + menu.offsetHeight}px` };
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-desktop {
  //margin-bottom: 16px;
}
.nav-menu {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 125%; /* 17.5px */
  text-transform: uppercase;
  min-height: 50px;
  border-top: 1px solid #cacece;
  border-bottom: 1px solid #cacece;
}
.nav-item {
  flex-grow: 1;
  display: flex;

  &:not(:last-child):after {
    content: '';
    display: block;
    height: 20px;
    width: 1px;
    background-color: #cacece;
    margin-left: auto;
    margin-right: auto;
  }

  &_red {
    color: var(--color-red);
  }
  &_active {
    .nav-item__underline {
      &:after {
        transform: scaleX(1);
      }
    }
  }
  &__underline {
    position: relative;
    &:before {
      content: '';
      display: block;
      position: absolute;
      left: -4px;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: currentcolor;
      transition: 0.2s linear transform;
      transform: scaleX(0);
    }
    &:after {
      content: '';
      display: block;
      height: 1px;
      background-color: currentColor;
      transition: 0.2s linear transform;
      transform: scaleX(0);
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
